module.exports = __webpack_public_path__ + "static/img/tersa_01.9b92ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tersa_01.png
// module id = 6Bss
// module chunks = 0